import { createBrowserRouter, RouterProvider } from 'react-router'
import './modules/i18next/i18next'
import routes from './routes'
import { lazy, Suspense, type ReactNode } from 'react'
import { MuiProvider } from './modules/mui/provider'
import { ReactQueryProvider } from './modules/react-query/provider'
import { IntlProvider } from './modules/i18next/provider'
import { Auth0Provider } from './modules/auth/provider'

const LazyLoadRoute = lazy(() => import('./components/lazy-load-route'))

const ActionSnackbar = lazy(
  () => import('./components/action-snackbar/action-snackbar'),
)

const router = createBrowserRouter(routes)

export default function App() {
  return (
    <Providers>
      <Suspense fallback={null}>
        <LazyLoadRoute>
          <RouterProvider router={router} />
        </LazyLoadRoute>
        <ActionSnackbar />
      </Suspense>
    </Providers>
  )
}

function Providers({ children }: { children: ReactNode }) {
  return (
    <IntlProvider>
      <Auth0Provider>
        <ReactQueryProvider>
          <MuiProvider>{children}</MuiProvider>
        </ReactQueryProvider>
      </Auth0Provider>
    </IntlProvider>
  )
}
